module.exports = __webpack_public_path__ + "assets/YouTube-minimal.f22c0225.svg";